import type {ExtractPropsWithoutRef} from '@/types';

import {IconLocationOnOutlined} from '@travel-frontend/icons';
import {Fade} from '@travel-frontend/ui-components';
import {forwardRef, memo} from 'react';
import {useTranslation} from 'react-i18next';

import {FloatingActionButton} from '@/components/FloatingActionButton';

type Props = ExtractPropsWithoutRef<typeof FloatingActionButton> & {
  visible: boolean;
};

const FloatingMapButtonComponent = forwardRef<HTMLButtonElement, Props>(
  function FloatingMapButton({visible, ...restProps}, ref) {
    const {t} = useTranslation('hotels');

    return (
      <Fade in={visible} appear mountOnEnter unmountOnExit>
        <FloatingActionButton
          {...restProps}
          ref={ref}
          width="343px"
          icon={<IconLocationOnOutlined />}
        >
          {t('floatingMapButton.label')}
        </FloatingActionButton>
      </Fade>
    );
  }
);

export const FloatingMapButton = memo(FloatingMapButtonComponent);
